var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo-container",attrs:{"to":{ name: _vm.homeRoute }}},[_c('div',{staticClass:"logo-inner"},[_c('img',{attrs:{"src":_vm.company.logo,"alt":_vm.$t(("global." + (_vm.company.name)))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }